/**
 * Copyright (c) Simam Digital.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Firebase web-app configuration.
 *
 * These values are PUBLIC and safe to ship in client code — Firebase security is
 * enforced by Auth + Firestore security rules, not by hiding this config.
 *
 * To fill the REPLACE_ME values:
 *   Firebase Console -> Project settings (gear) -> "Your apps" -> Web app
 *   -> SDK setup and configuration -> Config.
 * If you haven't created a Web app yet, click "Add app" -> Web (</>) first.
 */
export const firebaseConfig = {
	apiKey: 'AIzaSyB10KbMEnRbf6C4ozie0ZqYa7DnjcsLFoY',
	authDomain: 'garden-xr-social.firebaseapp.com',
	projectId: 'garden-xr-social',
	storageBucket: 'garden-xr-social.firebasestorage.app',
	messagingSenderId: '574670937564',
	appId: '1:574670937564:web:a318913470ce118b388319',
	measurementId: 'G-JK5CXS0WY9',
};
